/** Copy of the create-data-story dialog chrome (F04). */
export const CREATE_FLOW_COPY = {
  cancel: "Cancel",
  workspace: (name: string) => `Workspace \u00b7 ${name}`,
} as const;
